export const queryKeys = {
  menu: {
    all: ["menu"] as const,
  },
  categories: {
    all: ["categories"] as const,
  },
  orders: {
    all: ["orders"] as const,
    list: (status: string = "all") => ["orders", "list", status] as const,
    detail: (id: number) => ["orders", "detail", id] as const,
  },
};
